<div class="w-full p-2 bg-card rounded-md relative">
    <h3 class="text-normal text-xl text-center mb-3">
        {{(item?._id ?'edit_sticker':'add_sticker') | translate}}
    </h3>
    <button *ngIf="item?._id" (click)="cancelEdit()" class="absolute top-2 right-2 text-gray-500 hover:text-red-500">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
    </button>
    <app-image-input [formats]="[EFileTypes.GLOBALIMAGE]" (onChangeInput)="setImage($event)"  [showHeder]="false"   [size] = "bannerSizes[4]">
        <div class='rounded-md m-auto  bg-bg_primary border border-dashed bg-cover bg-center border-gray-500 block app-custom-modal-action text-center h-50 w-40'>
            <div class="text-center relative">
                @if (productImage){
                    <img [src]="productImage?.s3Url" class="w-full bg-gray-600 h-full object-cover"  alt="">

                } @else {
                    <svg class="mx-auto text-gray-500" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25h2.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z" clip-rule="evenodd" />
                    </svg>

                }
                <p class="text-xs leading-5 text-gray-400">{{ "upload_sticker" | translate }}</p>
            </div>
        </div>
    </app-image-input>

    <div class="grid grid-cols-2 gap-4">
        <div class="mt-2 col-span-2">
            <app-input type="number"
                       placeholder="write_amount"
                       [label]="('price'| translate) + ' ('+ currency  +')'"
                       [labelClass]="'!text-start'"
                       [formControlItem]="stickerForm.controls['price']"
            ></app-input>
        </div>


        <div class="mt-2 col-span-2">
            <app-input-range type="range"
                       placeholder="select_duration"
                       label="visible_duration"
                       [labelClass]="'!text-start'"
                       metrica="seconds"
                       [formControlItem]="stickerForm.controls['duration']"
            ></app-input-range>
        </div>

        <div>
            @if(item?._id){
                <white-label-button type="secondary" (onClick)="cancelEdit()" [text]="'cancel'| translate"></white-label-button>
            }
        </div>
        <div>
            <white-label-button (onClick)="save()" [text]="'save'| translate"></white-label-button>
        </div>
    </div>
</div>
